import React from 'react'
import { useState } from 'react'
import MyButton from '../../../../UI/form/MyButton'
import MyModal from '../../../../UI/modal/MyModal'
import AgreeLeaderForm from './AgreeLeaderForm'
import VisibilityIcon from '@mui/icons-material/Visibility';

const AgreeLeaderButton = () => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            onClick={e => setOpen(true)}
        >
            <VisibilityIcon />
        </MyButton>

        <MyModal
            classNameAdd='supplyOrderModal'
            open={open}
            setOpen={setOpen}
            header={'Погодження обраних рахунків'}
            disableClickOutside={true}
            content={
                <AgreeLeaderForm
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default AgreeLeaderButton